import React, { useState } from 'react';
import { getAuth, signInWithEmailAndPassword } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';

function Login() {
    const auth = getAuth();
    const navigate = useNavigate();

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');

    const handleLogin = async (e) => {
        e.preventDefault();
        setError('');
        try {
            await signInWithEmailAndPassword(auth, email, password);
            navigate('/dashboard');
        } catch (err) {
            setError('😢 Login failed: ' + err.message.replace("Firebase:", "").replace("auth/", "").replace(/-/g, ' '));
        }
    };

    return (
        <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '100vh',
            background: 'url("https://bliggles.com/static/media/website_background.png") no-repeat center center fixed',
            backgroundSize: 'cover',
            fontFamily: "'Raleway', sans-serif",
            color: '#fff'
        }}>
            <div style={{
                background: 'rgba(0, 0, 0, 0.8)',
                padding: '40px',
                borderRadius: '20px',
                width: '350px',
                boxShadow: '0 0 25px rgba(255, 255, 255, 0.3)'
            }}>
                <h2 style={{
                    fontFamily: "'Cinzel Decorative', cursive",
                    textAlign: 'center',
                    marginBottom: '20px',
                    color: '#fff',
                    textShadow: '0 0 10px #ff66cc'
                }}>🔐 Login to Bliggles</h2>

                <form onSubmit={handleLogin} style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
                    <input
                        type="email"
                        placeholder="Email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                        style={{
                            padding: '12px',
                            borderRadius: '12px',
                            border: 'none',
                            boxShadow: '0 0 10px rgba(255, 255, 255, 0.2)',
                            fontSize: '1rem'
                        }}
                    />
                    <input
                        type="password"
                        placeholder="Password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                        style={{
                            padding: '12px',
                            borderRadius: '12px',
                            border: 'none',
                            boxShadow: '0 0 10px rgba(255, 255, 255, 0.2)',
                            fontSize: '1rem'
                        }}
                    />
                    <button type="submit" style={{
                        padding: '12px',
                        borderRadius: '12px',
                        border: 'none',
                        fontWeight: 'bold',
                        fontSize: '1rem',
                        background: 'linear-gradient(135deg, #a18cd1, #fbc2eb)',
                        color: '#fff',
                        cursor: 'pointer',
                        transition: 'transform 0.2s ease',
                        boxShadow: '0 0 15px #fff5'
                    }}>✨ Enter the Mischief ✨</button>
                    {error && (
                        <p style={{
                            color: '#ffb3b3',
                            fontSize: '0.9rem',
                            textAlign: 'center',
                            background: '#44000088',
                            padding: '10px',
                            borderRadius: '10px'
                        }}>{error}</p>
                    )}
                </form>
            </div>
        </div>
    );
}

export default Login;
